import {
  MentorshipStatus,
  useMentorshipsByStudent,
} from "@/entities/mentorship";
import { useSessionStore } from "@/entities/session";
import { numberWithSpaces } from "@/shared/lib/utils";
import { ProgressBar } from "@/shared/ui/ProgressBar";
import { Card } from "@/shared/ui/card";

export const IncreasedRateProgressCard = () => {
  const { user } = useSessionStore();
  const _id = user?._id!;

  const { data, isLoading } = useMentorshipsByStudent({
    pageSize: 1,
    currentPage: 1,
    studentId: _id,
  });

  if (isLoading || !data?.data[0]) {
    return null;
  }

  const grossIncome = data.data[0].grossIncome;
  const status = data.data[0].status;

  if (grossIncome >= 10000 || status === MentorshipStatus.INACTIVE) {
    return null;
  }

  return (
    <Card className="flex flex-col items-center gap-2 p-4">
      <span className="font-bold">До перехода на 40%</span>
      <div>
        <span className="font-bold text-[#3179FF]">
          $ {numberWithSpaces(grossIncome)}{" "}
        </span>
        <span className="font-bold text-textGrayColor"> / $ 10 000</span>
      </div>
      <ProgressBar progress={(grossIncome / 10000) * 100} />
    </Card>
  );
};
